import SequentialIcons from '@/components/shared/components/icon/sequential';

export { SequentialIcons };
